import { useNavigate } from 'react-router-dom';

export const RequestDowngrade = () => {
    const navigate = useNavigate();
    return (
        <div className="p-2 lg:p-8">
            <div className="text-2xl font-bold mb-8 text-center">Request Downgrade</div>
            <div className="text-center">
                <p>Please contact us at <a href="mailto:support@ivestclub.fund" className="text-blue-500">support@ivestclub.fund</a> to request a downgrade. We will process your request and notify you via email when it is complete.</p>
            </div>
            <div className="text-center mt-8">
                <button className="bg-blue-500 text-white px-4 py-2 rounded-md" onClick={() => navigate('/dashboard')}>
                    Go to Dashboard
                </button>
            </div>
        </div>
    )
}